import { render } from "./EmployeesPage.vue?vue&type=template&id=10fcd51e&ts=true"
import script from "./EmployeesPage.vue?vue&type=script&lang=ts"
export * from "./EmployeesPage.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./EmployeesPage.vue?vue&type=style&index=0&id=10fcd51e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__